import { render, staticRenderFns } from "./RedirectHome.vue?vue&type=template&id=4582666c&"
import script from "./RedirectHome.vue?vue&type=script&lang=js&"
export * from "./RedirectHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports